// @ts-nocheck
/* eslint-disable */
'use strict';
module.exports = validate14;
module.exports.default = validate14;
const schema16 = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  $id: 'http://watershedclimate.com/canonical/v0.01/schema#',
  title: 'Watershed canonical schema meta-schema',
  definitions: {
    schemaArray: { type: 'array', minItems: 1, items: { $ref: '#' } },
    nonNegativeInteger: { type: 'integer', minimum: 0 },
    nonNegativeIntegerDefault0: {
      allOf: [{ $ref: '#/definitions/nonNegativeInteger' }, { default: 0 }],
    },
    simpleTypes: { enum: ['object', 'boolean', 'integer', 'number', 'string'] },
    stringArray: {
      type: 'array',
      items: { type: 'string' },
      uniqueItems: true,
      default: [],
    },
    standardizerArray: {
      type: 'array',
      items: { type: 'string', enum: ['HiggYarnDtex'] },
      uniqueItems: true,
      default: [],
    },
    field: {
      type: 'object',
      properties: {
        type: { enum: ['boolean', 'number', 'integer', 'string'] },
        description: { type: 'string' },
        format: {
          enum: [
            'date',
            'date-time',
            'us-date',
            'eu-date',
            'us-date-time',
            'eu-date-time',
            'us-number',
            'eu-number',
            'epoch-days',
            'epoch-seconds',
            'epoch-millis',
          ],
        },
        enum: {
          type: 'array',
          minItems: 1,
          uniqueItems: true,
          items: {
            oneOf: [{ type: 'string' }, { type: 'number' }, { type: 'null' }],
          },
        },
        examples: {
          type: 'array',
          items: { oneOf: [{ type: 'string' }, { type: 'number' }] },
        },
        default: {
          oneOf: [{ type: 'string' }, { type: 'number' }, { type: 'boolean' }],
        },
        deprecated: { type: 'boolean', default: false },
        storeAsHundredth: { type: 'boolean', default: false },
        displayName: { type: 'string' },
        nullable: { type: 'boolean' },
        errorMessage: { type: 'string' },
        unit: { type: 'string' },
        unitColumn: { type: 'string' },
      },
      required: ['type', 'description'],
    },
  },
  type: 'object',
  properties: {
    $id: { type: 'string', format: 'uri-reference' },
    $schema: { type: 'string', format: 'uri' },
    $ref: { type: 'string', format: 'uri-reference' },
    $comment: { type: 'string' },
    title: { type: 'string' },
    description: { type: 'string' },
    required: { $ref: '#/definitions/stringArray' },
    standardizerOutputOnly: { $ref: '#/definitions/stringArray' },
    standardizers: { $ref: '#/definitions/standardizerArray' },
    uniqueKeys: { $ref: '#/definitions/stringArray' },
    additionalProperties: { $ref: '#' },
    properties: {
      type: 'object',
      additionalProperties: { $ref: '#/definitions/field' },
    },
    patternProperties: {
      type: 'object',
      additionalProperties: { $ref: '#/definitions/field' },
      propertyNames: { format: 'regex' },
      default: {},
    },
    dependencies: {
      type: 'object',
      additionalProperties: {
        anyOf: [{ $ref: '#' }, { $ref: '#/definitions/stringArray' }],
      },
    },
    type: { const: 'object' },
  },
  required: ['type', 'properties'],
  default: true,
};
const schema17 = {
  type: 'array',
  items: { type: 'string' },
  uniqueItems: true,
  default: [],
};
const schema19 = {
  type: 'array',
  items: { type: 'string', enum: ['HiggYarnDtex'] },
  uniqueItems: true,
  default: [],
};
const schema21 = {
  type: 'object',
  properties: {
    type: { enum: ['boolean', 'number', 'integer', 'string'] },
    description: { type: 'string' },
    format: {
      enum: [
        'date',
        'date-time',
        'us-date',
        'eu-date',
        'us-date-time',
        'eu-date-time',
        'us-number',
        'eu-number',
        'epoch-days',
        'epoch-seconds',
        'epoch-millis',
      ],
    },
    enum: {
      type: 'array',
      minItems: 1,
      uniqueItems: true,
      items: {
        oneOf: [{ type: 'string' }, { type: 'number' }, { type: 'null' }],
      },
    },
    examples: {
      type: 'array',
      items: { oneOf: [{ type: 'string' }, { type: 'number' }] },
    },
    default: {
      oneOf: [{ type: 'string' }, { type: 'number' }, { type: 'boolean' }],
    },
    deprecated: { type: 'boolean', default: false },
    storeAsHundredth: { type: 'boolean', default: false },
    displayName: { type: 'string' },
    nullable: { type: 'boolean' },
    errorMessage: { type: 'string' },
    unit: { type: 'string' },
    unitColumn: { type: 'string' },
  },
  required: ['type', 'description'],
};
const formats0 =
  /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i;
const formats2 = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i;
const formats6 = require('ajv-formats/dist/formats').fastFormats.regex;
const func0 = require('ajv/dist/runtime/equal').default;
function validate14(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="http://watershedclimate.com/canonical/v0.01/schema#" */
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.type === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'type' },
        message: "must have required property '" + 'type' + "'",
        schema: schema16.required,
        parentSchema: schema16,
        data,
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.properties === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'properties' },
        message: "must have required property '" + 'properties' + "'",
        schema: schema16.required,
        parentSchema: schema16,
        data,
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.$id !== undefined) {
      let data0 = data.$id;
      if (typeof data0 === 'string') {
        if (!formats0.test(data0)) {
          const err2 = {
            instancePath: instancePath + '/$id',
            schemaPath: '#/properties/%24id/format',
            keyword: 'format',
            params: { format: 'uri-reference' },
            message: 'must match format "' + 'uri-reference' + '"',
            schema: 'uri-reference',
            parentSchema: schema16.properties.$id,
            data: data0,
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = {
          instancePath: instancePath + '/$id',
          schemaPath: '#/properties/%24id/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
          schema: schema16.properties.$id.type,
          parentSchema: schema16.properties.$id,
          data: data0,
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.$schema !== undefined) {
      let data1 = data.$schema;
      if (typeof data1 === 'string') {
        if (!formats2.test(data1)) {
          const err4 = {
            instancePath: instancePath + '/$schema',
            schemaPath: '#/properties/%24schema/format',
            keyword: 'format',
            params: { format: 'uri' },
            message: 'must match format "' + 'uri' + '"',
            schema: 'uri',
            parentSchema: schema16.properties.$schema,
            data: data1,
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      } else {
        const err5 = {
          instancePath: instancePath + '/$schema',
          schemaPath: '#/properties/%24schema/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
          schema: schema16.properties.$schema.type,
          parentSchema: schema16.properties.$schema,
          data: data1,
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.$ref !== undefined) {
      let data2 = data.$ref;
      if (typeof data2 === 'string') {
        if (!formats0.test(data2)) {
          const err6 = {
            instancePath: instancePath + '/$ref',
            schemaPath: '#/properties/%24ref/format',
            keyword: 'format',
            params: { format: 'uri-reference' },
            message: 'must match format "' + 'uri-reference' + '"',
            schema: 'uri-reference',
            parentSchema: schema16.properties.$ref,
            data: data2,
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      } else {
        const err7 = {
          instancePath: instancePath + '/$ref',
          schemaPath: '#/properties/%24ref/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
          schema: schema16.properties.$ref.type,
          parentSchema: schema16.properties.$ref,
          data: data2,
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.$comment !== undefined) {
      let data3 = data.$comment;
      if (typeof data3 !== 'string') {
        const err8 = {
          instancePath: instancePath + '/$comment',
          schemaPath: '#/properties/%24comment/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
          schema: schema16.properties.$comment.type,
          parentSchema: schema16.properties.$comment,
          data: data3,
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.title !== undefined) {
      let data4 = data.title;
      if (typeof data4 !== 'string') {
        const err9 = {
          instancePath: instancePath + '/title',
          schemaPath: '#/properties/title/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
          schema: schema16.properties.title.type,
          parentSchema: schema16.properties.title,
          data: data4,
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.description !== undefined) {
      let data5 = data.description;
      if (typeof data5 !== 'string') {
        const err10 = {
          instancePath: instancePath + '/description',
          schemaPath: '#/properties/description/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
          schema: schema16.properties.description.type,
          parentSchema: schema16.properties.description,
          data: data5,
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.required !== undefined) {
      let data6 = data.required;
      if (Array.isArray(data6)) {
        const len0 = data6.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data7 = data6[i0];
          if (typeof data7 !== 'string') {
            const err11 = {
              instancePath: instancePath + '/required/' + i0,
              schemaPath: '#/definitions/stringArray/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
              schema: schema17.items.type,
              parentSchema: schema17.items,
              data: data7,
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
        let i1 = data6.length;
        let j0;
        if (i1 > 1) {
          const indices0 = {};
          for (; i1--; ) {
            let item0 = data6[i1];
            if (typeof item0 !== 'string') {
              continue;
            }
            if (typeof indices0[item0] == 'number') {
              j0 = indices0[item0];
              const err12 = {
                instancePath: instancePath + '/required',
                schemaPath: '#/definitions/stringArray/uniqueItems',
                keyword: 'uniqueItems',
                params: { i: i1, j: j0 },
                message:
                  'must NOT have duplicate items (items ## ' +
                  j0 +
                  ' and ' +
                  i1 +
                  ' are identical)',
                schema: true,
                parentSchema: schema17,
                data: data6,
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
              break;
            }
            indices0[item0] = i1;
          }
        }
      } else {
        const err13 = {
          instancePath: instancePath + '/required',
          schemaPath: '#/definitions/stringArray/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
          schema: schema17.type,
          parentSchema: schema17,
          data: data6,
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.standardizerOutputOnly !== undefined) {
      let data8 = data.standardizerOutputOnly;
      if (Array.isArray(data8)) {
        const len1 = data8.length;
        for (let i2 = 0; i2 < len1; i2++) {
          let data9 = data8[i2];
          if (typeof data9 !== 'string') {
            const err14 = {
              instancePath: instancePath + '/standardizerOutputOnly/' + i2,
              schemaPath: '#/definitions/stringArray/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
              schema: schema17.items.type,
              parentSchema: schema17.items,
              data: data9,
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
        let i3 = data8.length;
        let j1;
        if (i3 > 1) {
          const indices1 = {};
          for (; i3--; ) {
            let item1 = data8[i3];
            if (typeof item1 !== 'string') {
              continue;
            }
            if (typeof indices1[item1] == 'number') {
              j1 = indices1[item1];
              const err15 = {
                instancePath: instancePath + '/standardizerOutputOnly',
                schemaPath: '#/definitions/stringArray/uniqueItems',
                keyword: 'uniqueItems',
                params: { i: i3, j: j1 },
                message:
                  'must NOT have duplicate items (items ## ' +
                  j1 +
                  ' and ' +
                  i3 +
                  ' are identical)',
                schema: true,
                parentSchema: schema17,
                data: data8,
              };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
              break;
            }
            indices1[item1] = i3;
          }
        }
      } else {
        const err16 = {
          instancePath: instancePath + '/standardizerOutputOnly',
          schemaPath: '#/definitions/stringArray/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
          schema: schema17.type,
          parentSchema: schema17,
          data: data8,
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.standardizers !== undefined) {
      let data10 = data.standardizers;
      if (Array.isArray(data10)) {
        const len2 = data10.length;
        for (let i4 = 0; i4 < len2; i4++) {
          let data11 = data10[i4];
          if (typeof data11 !== 'string') {
            const err17 = {
              instancePath: instancePath + '/standardizers/' + i4,
              schemaPath: '#/definitions/standardizerArray/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
              schema: schema19.items.type,
              parentSchema: schema19.items,
              data: data11,
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
          if (!(data11 === 'HiggYarnDtex')) {
            const err18 = {
              instancePath: instancePath + '/standardizers/' + i4,
              schemaPath: '#/definitions/standardizerArray/items/enum',
              keyword: 'enum',
              params: { allowedValues: schema19.items.enum },
              message: 'must be equal to one of the allowed values',
              schema: schema19.items.enum,
              parentSchema: schema19.items,
              data: data11,
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
        let i5 = data10.length;
        let j2;
        if (i5 > 1) {
          const indices2 = {};
          for (; i5--; ) {
            let item2 = data10[i5];
            if (typeof item2 !== 'string') {
              continue;
            }
            if (typeof indices2[item2] == 'number') {
              j2 = indices2[item2];
              const err19 = {
                instancePath: instancePath + '/standardizers',
                schemaPath: '#/definitions/standardizerArray/uniqueItems',
                keyword: 'uniqueItems',
                params: { i: i5, j: j2 },
                message:
                  'must NOT have duplicate items (items ## ' +
                  j2 +
                  ' and ' +
                  i5 +
                  ' are identical)',
                schema: true,
                parentSchema: schema19,
                data: data10,
              };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
              break;
            }
            indices2[item2] = i5;
          }
        }
      } else {
        const err20 = {
          instancePath: instancePath + '/standardizers',
          schemaPath: '#/definitions/standardizerArray/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
          schema: schema19.type,
          parentSchema: schema19,
          data: data10,
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.uniqueKeys !== undefined) {
      let data12 = data.uniqueKeys;
      if (Array.isArray(data12)) {
        const len3 = data12.length;
        for (let i6 = 0; i6 < len3; i6++) {
          let data13 = data12[i6];
          if (typeof data13 !== 'string') {
            const err21 = {
              instancePath: instancePath + '/uniqueKeys/' + i6,
              schemaPath: '#/definitions/stringArray/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
              schema: schema17.items.type,
              parentSchema: schema17.items,
              data: data13,
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        let i7 = data12.length;
        let j3;
        if (i7 > 1) {
          const indices3 = {};
          for (; i7--; ) {
            let item3 = data12[i7];
            if (typeof item3 !== 'string') {
              continue;
            }
            if (typeof indices3[item3] == 'number') {
              j3 = indices3[item3];
              const err22 = {
                instancePath: instancePath + '/uniqueKeys',
                schemaPath: '#/definitions/stringArray/uniqueItems',
                keyword: 'uniqueItems',
                params: { i: i7, j: j3 },
                message:
                  'must NOT have duplicate items (items ## ' +
                  j3 +
                  ' and ' +
                  i7 +
                  ' are identical)',
                schema: true,
                parentSchema: schema17,
                data: data12,
              };
              if (vErrors === null) {
                vErrors = [err22];
              } else {
                vErrors.push(err22);
              }
              errors++;
              break;
            }
            indices3[item3] = i7;
          }
        }
      } else {
        const err23 = {
          instancePath: instancePath + '/uniqueKeys',
          schemaPath: '#/definitions/stringArray/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
          schema: schema17.type,
          parentSchema: schema17,
          data: data12,
        };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
    }
    if (data.additionalProperties !== undefined) {
      if (
        !validate14(data.additionalProperties, {
          instancePath: instancePath + '/additionalProperties',
          parentData: data,
          parentDataProperty: 'additionalProperties',
          rootData,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate14.errors
            : vErrors.concat(validate14.errors);
        errors = vErrors.length;
      }
    }
    if (data.properties !== undefined) {
      let data15 = data.properties;
      if (data15 && typeof data15 == 'object' && !Array.isArray(data15)) {
        for (const key0 in data15) {
          let data16 = data15[key0];
          if (data16 && typeof data16 == 'object' && !Array.isArray(data16)) {
            if (data16.type === undefined) {
              const err24 = {
                instancePath:
                  instancePath +
                  '/properties/' +
                  key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                schemaPath: '#/definitions/field/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema21.required,
                parentSchema: schema21,
                data: data16,
              };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            if (data16.description === undefined) {
              const err25 = {
                instancePath:
                  instancePath +
                  '/properties/' +
                  key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                schemaPath: '#/definitions/field/required',
                keyword: 'required',
                params: { missingProperty: 'description' },
                message: "must have required property '" + 'description' + "'",
                schema: schema21.required,
                parentSchema: schema21,
                data: data16,
              };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (data16.type !== undefined) {
              let data17 = data16.type;
              if (
                !(
                  data17 === 'boolean' ||
                  data17 === 'number' ||
                  data17 === 'integer' ||
                  data17 === 'string'
                )
              ) {
                const err26 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/type',
                  schemaPath: '#/definitions/field/properties/type/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema21.properties.type.enum },
                  message: 'must be equal to one of the allowed values',
                  schema: schema21.properties.type.enum,
                  parentSchema: schema21.properties.type,
                  data: data17,
                };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
            if (data16.description !== undefined) {
              let data18 = data16.description;
              if (typeof data18 !== 'string') {
                const err27 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/description',
                  schemaPath: '#/definitions/field/properties/description/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.description.type,
                  parentSchema: schema21.properties.description,
                  data: data18,
                };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
            if (data16.format !== undefined) {
              let data19 = data16.format;
              if (
                !(
                  data19 === 'date' ||
                  data19 === 'date-time' ||
                  data19 === 'us-date' ||
                  data19 === 'eu-date' ||
                  data19 === 'us-date-time' ||
                  data19 === 'eu-date-time' ||
                  data19 === 'us-number' ||
                  data19 === 'eu-number' ||
                  data19 === 'epoch-days' ||
                  data19 === 'epoch-seconds' ||
                  data19 === 'epoch-millis'
                )
              ) {
                const err28 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/format',
                  schemaPath: '#/definitions/field/properties/format/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema21.properties.format.enum },
                  message: 'must be equal to one of the allowed values',
                  schema: schema21.properties.format.enum,
                  parentSchema: schema21.properties.format,
                  data: data19,
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            if (data16.enum !== undefined) {
              let data20 = data16.enum;
              if (Array.isArray(data20)) {
                if (data20.length < 1) {
                  const err29 = {
                    instancePath:
                      instancePath +
                      '/properties/' +
                      key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                      '/enum',
                    schemaPath: '#/definitions/field/properties/enum/minItems',
                    keyword: 'minItems',
                    params: { limit: 1 },
                    message: 'must NOT have fewer than 1 items',
                    schema: 1,
                    parentSchema: schema21.properties.enum,
                    data: data20,
                  };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
                const len4 = data20.length;
                for (let i8 = 0; i8 < len4; i8++) {
                  let data21 = data20[i8];
                  const _errs47 = errors;
                  let valid22 = false;
                  let passing0 = null;
                  const _errs48 = errors;
                  if (typeof data21 !== 'string') {
                    const err30 = {
                      instancePath:
                        instancePath +
                        '/properties/' +
                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/enum/' +
                        i8,
                      schemaPath:
                        '#/definitions/field/properties/enum/items/oneOf/0/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                      schema: schema21.properties.enum.items.oneOf[0].type,
                      parentSchema: schema21.properties.enum.items.oneOf[0],
                      data: data21,
                    };
                    if (vErrors === null) {
                      vErrors = [err30];
                    } else {
                      vErrors.push(err30);
                    }
                    errors++;
                  }
                  var _valid0 = _errs48 === errors;
                  if (_valid0) {
                    valid22 = true;
                    passing0 = 0;
                  }
                  const _errs50 = errors;
                  if (!(typeof data21 == 'number' && isFinite(data21))) {
                    const err31 = {
                      instancePath:
                        instancePath +
                        '/properties/' +
                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/enum/' +
                        i8,
                      schemaPath:
                        '#/definitions/field/properties/enum/items/oneOf/1/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                      schema: schema21.properties.enum.items.oneOf[1].type,
                      parentSchema: schema21.properties.enum.items.oneOf[1],
                      data: data21,
                    };
                    if (vErrors === null) {
                      vErrors = [err31];
                    } else {
                      vErrors.push(err31);
                    }
                    errors++;
                  }
                  var _valid0 = _errs50 === errors;
                  if (_valid0 && valid22) {
                    valid22 = false;
                    passing0 = [passing0, 1];
                  } else {
                    if (_valid0) {
                      valid22 = true;
                      passing0 = 1;
                    }
                    const _errs52 = errors;
                    if (data21 !== null) {
                      const err32 = {
                        instancePath:
                          instancePath +
                          '/properties/' +
                          key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                          '/enum/' +
                          i8,
                        schemaPath:
                          '#/definitions/field/properties/enum/items/oneOf/2/type',
                        keyword: 'type',
                        params: { type: 'null' },
                        message: 'must be null',
                        schema: schema21.properties.enum.items.oneOf[2].type,
                        parentSchema: schema21.properties.enum.items.oneOf[2],
                        data: data21,
                      };
                      if (vErrors === null) {
                        vErrors = [err32];
                      } else {
                        vErrors.push(err32);
                      }
                      errors++;
                    }
                    var _valid0 = _errs52 === errors;
                    if (_valid0 && valid22) {
                      valid22 = false;
                      passing0 = [passing0, 2];
                    } else {
                      if (_valid0) {
                        valid22 = true;
                        passing0 = 2;
                      }
                    }
                  }
                  if (!valid22) {
                    const err33 = {
                      instancePath:
                        instancePath +
                        '/properties/' +
                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/enum/' +
                        i8,
                      schemaPath:
                        '#/definitions/field/properties/enum/items/oneOf',
                      keyword: 'oneOf',
                      params: { passingSchemas: passing0 },
                      message: 'must match exactly one schema in oneOf',
                      schema: schema21.properties.enum.items.oneOf,
                      parentSchema: schema21.properties.enum.items,
                      data: data21,
                    };
                    if (vErrors === null) {
                      vErrors = [err33];
                    } else {
                      vErrors.push(err33);
                    }
                    errors++;
                  } else {
                    errors = _errs47;
                    if (vErrors !== null) {
                      if (_errs47) {
                        vErrors.length = _errs47;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                }
                let i9 = data20.length;
                let j4;
                if (i9 > 1) {
                  outer0: for (; i9--; ) {
                    for (j4 = i9; j4--; ) {
                      if (func0(data20[i9], data20[j4])) {
                        const err34 = {
                          instancePath:
                            instancePath +
                            '/properties/' +
                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                            '/enum',
                          schemaPath:
                            '#/definitions/field/properties/enum/uniqueItems',
                          keyword: 'uniqueItems',
                          params: { i: i9, j: j4 },
                          message:
                            'must NOT have duplicate items (items ## ' +
                            j4 +
                            ' and ' +
                            i9 +
                            ' are identical)',
                          schema: true,
                          parentSchema: schema21.properties.enum,
                          data: data20,
                        };
                        if (vErrors === null) {
                          vErrors = [err34];
                        } else {
                          vErrors.push(err34);
                        }
                        errors++;
                        break outer0;
                      }
                    }
                  }
                }
              } else {
                const err35 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/enum',
                  schemaPath: '#/definitions/field/properties/enum/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                  schema: schema21.properties.enum.type,
                  parentSchema: schema21.properties.enum,
                  data: data20,
                };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
            }
            if (data16.examples !== undefined) {
              let data22 = data16.examples;
              if (Array.isArray(data22)) {
                const len5 = data22.length;
                for (let i10 = 0; i10 < len5; i10++) {
                  let data23 = data22[i10];
                  const _errs57 = errors;
                  let valid26 = false;
                  let passing1 = null;
                  const _errs58 = errors;
                  if (typeof data23 !== 'string') {
                    const err36 = {
                      instancePath:
                        instancePath +
                        '/properties/' +
                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/examples/' +
                        i10,
                      schemaPath:
                        '#/definitions/field/properties/examples/items/oneOf/0/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                      schema: schema21.properties.examples.items.oneOf[0].type,
                      parentSchema: schema21.properties.examples.items.oneOf[0],
                      data: data23,
                    };
                    if (vErrors === null) {
                      vErrors = [err36];
                    } else {
                      vErrors.push(err36);
                    }
                    errors++;
                  }
                  var _valid1 = _errs58 === errors;
                  if (_valid1) {
                    valid26 = true;
                    passing1 = 0;
                  }
                  const _errs60 = errors;
                  if (!(typeof data23 == 'number' && isFinite(data23))) {
                    const err37 = {
                      instancePath:
                        instancePath +
                        '/properties/' +
                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/examples/' +
                        i10,
                      schemaPath:
                        '#/definitions/field/properties/examples/items/oneOf/1/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                      schema: schema21.properties.examples.items.oneOf[1].type,
                      parentSchema: schema21.properties.examples.items.oneOf[1],
                      data: data23,
                    };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                  }
                  var _valid1 = _errs60 === errors;
                  if (_valid1 && valid26) {
                    valid26 = false;
                    passing1 = [passing1, 1];
                  } else {
                    if (_valid1) {
                      valid26 = true;
                      passing1 = 1;
                    }
                  }
                  if (!valid26) {
                    const err38 = {
                      instancePath:
                        instancePath +
                        '/properties/' +
                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/examples/' +
                        i10,
                      schemaPath:
                        '#/definitions/field/properties/examples/items/oneOf',
                      keyword: 'oneOf',
                      params: { passingSchemas: passing1 },
                      message: 'must match exactly one schema in oneOf',
                      schema: schema21.properties.examples.items.oneOf,
                      parentSchema: schema21.properties.examples.items,
                      data: data23,
                    };
                    if (vErrors === null) {
                      vErrors = [err38];
                    } else {
                      vErrors.push(err38);
                    }
                    errors++;
                  } else {
                    errors = _errs57;
                    if (vErrors !== null) {
                      if (_errs57) {
                        vErrors.length = _errs57;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                }
              } else {
                const err39 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/examples',
                  schemaPath: '#/definitions/field/properties/examples/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                  schema: schema21.properties.examples.type,
                  parentSchema: schema21.properties.examples,
                  data: data22,
                };
                if (vErrors === null) {
                  vErrors = [err39];
                } else {
                  vErrors.push(err39);
                }
                errors++;
              }
            }
            if (data16.default !== undefined) {
              let data24 = data16.default;
              const _errs63 = errors;
              let valid27 = false;
              let passing2 = null;
              const _errs64 = errors;
              if (typeof data24 !== 'string') {
                const err40 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/default',
                  schemaPath:
                    '#/definitions/field/properties/default/oneOf/0/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.default.oneOf[0].type,
                  parentSchema: schema21.properties.default.oneOf[0],
                  data: data24,
                };
                if (vErrors === null) {
                  vErrors = [err40];
                } else {
                  vErrors.push(err40);
                }
                errors++;
              }
              var _valid2 = _errs64 === errors;
              if (_valid2) {
                valid27 = true;
                passing2 = 0;
              }
              const _errs66 = errors;
              if (!(typeof data24 == 'number' && isFinite(data24))) {
                const err41 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/default',
                  schemaPath:
                    '#/definitions/field/properties/default/oneOf/1/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                  schema: schema21.properties.default.oneOf[1].type,
                  parentSchema: schema21.properties.default.oneOf[1],
                  data: data24,
                };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
              var _valid2 = _errs66 === errors;
              if (_valid2 && valid27) {
                valid27 = false;
                passing2 = [passing2, 1];
              } else {
                if (_valid2) {
                  valid27 = true;
                  passing2 = 1;
                }
                const _errs68 = errors;
                if (typeof data24 !== 'boolean') {
                  const err42 = {
                    instancePath:
                      instancePath +
                      '/properties/' +
                      key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                      '/default',
                    schemaPath:
                      '#/definitions/field/properties/default/oneOf/2/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema21.properties.default.oneOf[2].type,
                    parentSchema: schema21.properties.default.oneOf[2],
                    data: data24,
                  };
                  if (vErrors === null) {
                    vErrors = [err42];
                  } else {
                    vErrors.push(err42);
                  }
                  errors++;
                }
                var _valid2 = _errs68 === errors;
                if (_valid2 && valid27) {
                  valid27 = false;
                  passing2 = [passing2, 2];
                } else {
                  if (_valid2) {
                    valid27 = true;
                    passing2 = 2;
                  }
                }
              }
              if (!valid27) {
                const err43 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/default',
                  schemaPath: '#/definitions/field/properties/default/oneOf',
                  keyword: 'oneOf',
                  params: { passingSchemas: passing2 },
                  message: 'must match exactly one schema in oneOf',
                  schema: schema21.properties.default.oneOf,
                  parentSchema: schema21.properties.default,
                  data: data24,
                };
                if (vErrors === null) {
                  vErrors = [err43];
                } else {
                  vErrors.push(err43);
                }
                errors++;
              } else {
                errors = _errs63;
                if (vErrors !== null) {
                  if (_errs63) {
                    vErrors.length = _errs63;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data16.deprecated !== undefined) {
              let data25 = data16.deprecated;
              if (typeof data25 !== 'boolean') {
                const err44 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/deprecated',
                  schemaPath: '#/definitions/field/properties/deprecated/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                  schema: schema21.properties.deprecated.type,
                  parentSchema: schema21.properties.deprecated,
                  data: data25,
                };
                if (vErrors === null) {
                  vErrors = [err44];
                } else {
                  vErrors.push(err44);
                }
                errors++;
              }
            }
            if (data16.storeAsHundredth !== undefined) {
              let data26 = data16.storeAsHundredth;
              if (typeof data26 !== 'boolean') {
                const err45 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/storeAsHundredth',
                  schemaPath:
                    '#/definitions/field/properties/storeAsHundredth/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                  schema: schema21.properties.storeAsHundredth.type,
                  parentSchema: schema21.properties.storeAsHundredth,
                  data: data26,
                };
                if (vErrors === null) {
                  vErrors = [err45];
                } else {
                  vErrors.push(err45);
                }
                errors++;
              }
            }
            if (data16.displayName !== undefined) {
              let data27 = data16.displayName;
              if (typeof data27 !== 'string') {
                const err46 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/displayName',
                  schemaPath: '#/definitions/field/properties/displayName/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.displayName.type,
                  parentSchema: schema21.properties.displayName,
                  data: data27,
                };
                if (vErrors === null) {
                  vErrors = [err46];
                } else {
                  vErrors.push(err46);
                }
                errors++;
              }
            }
            if (data16.nullable !== undefined) {
              let data28 = data16.nullable;
              if (typeof data28 !== 'boolean') {
                const err47 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/nullable',
                  schemaPath: '#/definitions/field/properties/nullable/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                  schema: schema21.properties.nullable.type,
                  parentSchema: schema21.properties.nullable,
                  data: data28,
                };
                if (vErrors === null) {
                  vErrors = [err47];
                } else {
                  vErrors.push(err47);
                }
                errors++;
              }
            }
            if (data16.errorMessage !== undefined) {
              let data29 = data16.errorMessage;
              if (typeof data29 !== 'string') {
                const err48 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/errorMessage',
                  schemaPath:
                    '#/definitions/field/properties/errorMessage/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.errorMessage.type,
                  parentSchema: schema21.properties.errorMessage,
                  data: data29,
                };
                if (vErrors === null) {
                  vErrors = [err48];
                } else {
                  vErrors.push(err48);
                }
                errors++;
              }
            }
            if (data16.unit !== undefined) {
              let data30 = data16.unit;
              if (typeof data30 !== 'string') {
                const err49 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/unit',
                  schemaPath: '#/definitions/field/properties/unit/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.unit.type,
                  parentSchema: schema21.properties.unit,
                  data: data30,
                };
                if (vErrors === null) {
                  vErrors = [err49];
                } else {
                  vErrors.push(err49);
                }
                errors++;
              }
            }
            if (data16.unitColumn !== undefined) {
              let data31 = data16.unitColumn;
              if (typeof data31 !== 'string') {
                const err50 = {
                  instancePath:
                    instancePath +
                    '/properties/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/unitColumn',
                  schemaPath: '#/definitions/field/properties/unitColumn/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.unitColumn.type,
                  parentSchema: schema21.properties.unitColumn,
                  data: data31,
                };
                if (vErrors === null) {
                  vErrors = [err50];
                } else {
                  vErrors.push(err50);
                }
                errors++;
              }
            }
          } else {
            const err51 = {
              instancePath:
                instancePath +
                '/properties/' +
                key0.replace(/~/g, '~0').replace(/\//g, '~1'),
              schemaPath: '#/definitions/field/type',
              keyword: 'type',
              params: { type: 'object' },
              message: 'must be object',
              schema: schema21.type,
              parentSchema: schema21,
              data: data16,
            };
            if (vErrors === null) {
              vErrors = [err51];
            } else {
              vErrors.push(err51);
            }
            errors++;
          }
        }
      } else {
        const err52 = {
          instancePath: instancePath + '/properties',
          schemaPath: '#/properties/properties/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
          schema: schema16.properties.properties.type,
          parentSchema: schema16.properties.properties,
          data: data15,
        };
        if (vErrors === null) {
          vErrors = [err52];
        } else {
          vErrors.push(err52);
        }
        errors++;
      }
    }
    if (data.patternProperties !== undefined) {
      let data32 = data.patternProperties;
      if (data32 && typeof data32 == 'object' && !Array.isArray(data32)) {
        for (const key1 in data32) {
          const _errs86 = errors;
          if (typeof key1 === 'string') {
            if (!formats6(key1)) {
              const err53 = {
                instancePath: instancePath + '/patternProperties',
                schemaPath:
                  '#/properties/patternProperties/propertyNames/format',
                keyword: 'format',
                params: { format: 'regex' },
                message: 'must match format "' + 'regex' + '"',
                schema: 'regex',
                parentSchema:
                  schema16.properties.patternProperties.propertyNames,
                data: key1,
                propertyName: key1,
              };
              if (vErrors === null) {
                vErrors = [err53];
              } else {
                vErrors.push(err53);
              }
              errors++;
            }
          }
          var valid28 = _errs86 === errors;
          if (!valid28) {
            const err54 = {
              instancePath: instancePath + '/patternProperties',
              schemaPath: '#/properties/patternProperties/propertyNames',
              keyword: 'propertyNames',
              params: { propertyName: key1 },
              message: 'property name must be valid',
              schema: schema16.properties.patternProperties.propertyNames,
              parentSchema: schema16.properties.patternProperties,
              data: data32,
            };
            if (vErrors === null) {
              vErrors = [err54];
            } else {
              vErrors.push(err54);
            }
            errors++;
          }
        }
        for (const key2 in data32) {
          let data33 = data32[key2];
          if (data33 && typeof data33 == 'object' && !Array.isArray(data33)) {
            if (data33.type === undefined) {
              const err55 = {
                instancePath:
                  instancePath +
                  '/patternProperties/' +
                  key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                schemaPath: '#/definitions/field/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema21.required,
                parentSchema: schema21,
                data: data33,
              };
              if (vErrors === null) {
                vErrors = [err55];
              } else {
                vErrors.push(err55);
              }
              errors++;
            }
            if (data33.description === undefined) {
              const err56 = {
                instancePath:
                  instancePath +
                  '/patternProperties/' +
                  key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                schemaPath: '#/definitions/field/required',
                keyword: 'required',
                params: { missingProperty: 'description' },
                message: "must have required property '" + 'description' + "'",
                schema: schema21.required,
                parentSchema: schema21,
                data: data33,
              };
              if (vErrors === null) {
                vErrors = [err56];
              } else {
                vErrors.push(err56);
              }
              errors++;
            }
            if (data33.type !== undefined) {
              let data34 = data33.type;
              if (
                !(
                  data34 === 'boolean' ||
                  data34 === 'number' ||
                  data34 === 'integer' ||
                  data34 === 'string'
                )
              ) {
                const err57 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/type',
                  schemaPath: '#/definitions/field/properties/type/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema21.properties.type.enum },
                  message: 'must be equal to one of the allowed values',
                  schema: schema21.properties.type.enum,
                  parentSchema: schema21.properties.type,
                  data: data34,
                };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              }
            }
            if (data33.description !== undefined) {
              let data35 = data33.description;
              if (typeof data35 !== 'string') {
                const err58 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/description',
                  schemaPath: '#/definitions/field/properties/description/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.description.type,
                  parentSchema: schema21.properties.description,
                  data: data35,
                };
                if (vErrors === null) {
                  vErrors = [err58];
                } else {
                  vErrors.push(err58);
                }
                errors++;
              }
            }
            if (data33.format !== undefined) {
              let data36 = data33.format;
              if (
                !(
                  data36 === 'date' ||
                  data36 === 'date-time' ||
                  data36 === 'us-date' ||
                  data36 === 'eu-date' ||
                  data36 === 'us-date-time' ||
                  data36 === 'eu-date-time' ||
                  data36 === 'us-number' ||
                  data36 === 'eu-number' ||
                  data36 === 'epoch-days' ||
                  data36 === 'epoch-seconds' ||
                  data36 === 'epoch-millis'
                )
              ) {
                const err59 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/format',
                  schemaPath: '#/definitions/field/properties/format/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema21.properties.format.enum },
                  message: 'must be equal to one of the allowed values',
                  schema: schema21.properties.format.enum,
                  parentSchema: schema21.properties.format,
                  data: data36,
                };
                if (vErrors === null) {
                  vErrors = [err59];
                } else {
                  vErrors.push(err59);
                }
                errors++;
              }
            }
            if (data33.enum !== undefined) {
              let data37 = data33.enum;
              if (Array.isArray(data37)) {
                if (data37.length < 1) {
                  const err60 = {
                    instancePath:
                      instancePath +
                      '/patternProperties/' +
                      key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                      '/enum',
                    schemaPath: '#/definitions/field/properties/enum/minItems',
                    keyword: 'minItems',
                    params: { limit: 1 },
                    message: 'must NOT have fewer than 1 items',
                    schema: 1,
                    parentSchema: schema21.properties.enum,
                    data: data37,
                  };
                  if (vErrors === null) {
                    vErrors = [err60];
                  } else {
                    vErrors.push(err60);
                  }
                  errors++;
                }
                const len6 = data37.length;
                for (let i11 = 0; i11 < len6; i11++) {
                  let data38 = data37[i11];
                  const _errs98 = errors;
                  let valid34 = false;
                  let passing3 = null;
                  const _errs99 = errors;
                  if (typeof data38 !== 'string') {
                    const err61 = {
                      instancePath:
                        instancePath +
                        '/patternProperties/' +
                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/enum/' +
                        i11,
                      schemaPath:
                        '#/definitions/field/properties/enum/items/oneOf/0/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                      schema: schema21.properties.enum.items.oneOf[0].type,
                      parentSchema: schema21.properties.enum.items.oneOf[0],
                      data: data38,
                    };
                    if (vErrors === null) {
                      vErrors = [err61];
                    } else {
                      vErrors.push(err61);
                    }
                    errors++;
                  }
                  var _valid3 = _errs99 === errors;
                  if (_valid3) {
                    valid34 = true;
                    passing3 = 0;
                  }
                  const _errs101 = errors;
                  if (!(typeof data38 == 'number' && isFinite(data38))) {
                    const err62 = {
                      instancePath:
                        instancePath +
                        '/patternProperties/' +
                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/enum/' +
                        i11,
                      schemaPath:
                        '#/definitions/field/properties/enum/items/oneOf/1/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                      schema: schema21.properties.enum.items.oneOf[1].type,
                      parentSchema: schema21.properties.enum.items.oneOf[1],
                      data: data38,
                    };
                    if (vErrors === null) {
                      vErrors = [err62];
                    } else {
                      vErrors.push(err62);
                    }
                    errors++;
                  }
                  var _valid3 = _errs101 === errors;
                  if (_valid3 && valid34) {
                    valid34 = false;
                    passing3 = [passing3, 1];
                  } else {
                    if (_valid3) {
                      valid34 = true;
                      passing3 = 1;
                    }
                    const _errs103 = errors;
                    if (data38 !== null) {
                      const err63 = {
                        instancePath:
                          instancePath +
                          '/patternProperties/' +
                          key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                          '/enum/' +
                          i11,
                        schemaPath:
                          '#/definitions/field/properties/enum/items/oneOf/2/type',
                        keyword: 'type',
                        params: { type: 'null' },
                        message: 'must be null',
                        schema: schema21.properties.enum.items.oneOf[2].type,
                        parentSchema: schema21.properties.enum.items.oneOf[2],
                        data: data38,
                      };
                      if (vErrors === null) {
                        vErrors = [err63];
                      } else {
                        vErrors.push(err63);
                      }
                      errors++;
                    }
                    var _valid3 = _errs103 === errors;
                    if (_valid3 && valid34) {
                      valid34 = false;
                      passing3 = [passing3, 2];
                    } else {
                      if (_valid3) {
                        valid34 = true;
                        passing3 = 2;
                      }
                    }
                  }
                  if (!valid34) {
                    const err64 = {
                      instancePath:
                        instancePath +
                        '/patternProperties/' +
                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/enum/' +
                        i11,
                      schemaPath:
                        '#/definitions/field/properties/enum/items/oneOf',
                      keyword: 'oneOf',
                      params: { passingSchemas: passing3 },
                      message: 'must match exactly one schema in oneOf',
                      schema: schema21.properties.enum.items.oneOf,
                      parentSchema: schema21.properties.enum.items,
                      data: data38,
                    };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  } else {
                    errors = _errs98;
                    if (vErrors !== null) {
                      if (_errs98) {
                        vErrors.length = _errs98;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                }
                let i12 = data37.length;
                let j5;
                if (i12 > 1) {
                  outer1: for (; i12--; ) {
                    for (j5 = i12; j5--; ) {
                      if (func0(data37[i12], data37[j5])) {
                        const err65 = {
                          instancePath:
                            instancePath +
                            '/patternProperties/' +
                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                            '/enum',
                          schemaPath:
                            '#/definitions/field/properties/enum/uniqueItems',
                          keyword: 'uniqueItems',
                          params: { i: i12, j: j5 },
                          message:
                            'must NOT have duplicate items (items ## ' +
                            j5 +
                            ' and ' +
                            i12 +
                            ' are identical)',
                          schema: true,
                          parentSchema: schema21.properties.enum,
                          data: data37,
                        };
                        if (vErrors === null) {
                          vErrors = [err65];
                        } else {
                          vErrors.push(err65);
                        }
                        errors++;
                        break outer1;
                      }
                    }
                  }
                }
              } else {
                const err66 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/enum',
                  schemaPath: '#/definitions/field/properties/enum/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                  schema: schema21.properties.enum.type,
                  parentSchema: schema21.properties.enum,
                  data: data37,
                };
                if (vErrors === null) {
                  vErrors = [err66];
                } else {
                  vErrors.push(err66);
                }
                errors++;
              }
            }
            if (data33.examples !== undefined) {
              let data39 = data33.examples;
              if (Array.isArray(data39)) {
                const len7 = data39.length;
                for (let i13 = 0; i13 < len7; i13++) {
                  let data40 = data39[i13];
                  const _errs108 = errors;
                  let valid38 = false;
                  let passing4 = null;
                  const _errs109 = errors;
                  if (typeof data40 !== 'string') {
                    const err67 = {
                      instancePath:
                        instancePath +
                        '/patternProperties/' +
                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/examples/' +
                        i13,
                      schemaPath:
                        '#/definitions/field/properties/examples/items/oneOf/0/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                      schema: schema21.properties.examples.items.oneOf[0].type,
                      parentSchema: schema21.properties.examples.items.oneOf[0],
                      data: data40,
                    };
                    if (vErrors === null) {
                      vErrors = [err67];
                    } else {
                      vErrors.push(err67);
                    }
                    errors++;
                  }
                  var _valid4 = _errs109 === errors;
                  if (_valid4) {
                    valid38 = true;
                    passing4 = 0;
                  }
                  const _errs111 = errors;
                  if (!(typeof data40 == 'number' && isFinite(data40))) {
                    const err68 = {
                      instancePath:
                        instancePath +
                        '/patternProperties/' +
                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/examples/' +
                        i13,
                      schemaPath:
                        '#/definitions/field/properties/examples/items/oneOf/1/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                      schema: schema21.properties.examples.items.oneOf[1].type,
                      parentSchema: schema21.properties.examples.items.oneOf[1],
                      data: data40,
                    };
                    if (vErrors === null) {
                      vErrors = [err68];
                    } else {
                      vErrors.push(err68);
                    }
                    errors++;
                  }
                  var _valid4 = _errs111 === errors;
                  if (_valid4 && valid38) {
                    valid38 = false;
                    passing4 = [passing4, 1];
                  } else {
                    if (_valid4) {
                      valid38 = true;
                      passing4 = 1;
                    }
                  }
                  if (!valid38) {
                    const err69 = {
                      instancePath:
                        instancePath +
                        '/patternProperties/' +
                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                        '/examples/' +
                        i13,
                      schemaPath:
                        '#/definitions/field/properties/examples/items/oneOf',
                      keyword: 'oneOf',
                      params: { passingSchemas: passing4 },
                      message: 'must match exactly one schema in oneOf',
                      schema: schema21.properties.examples.items.oneOf,
                      parentSchema: schema21.properties.examples.items,
                      data: data40,
                    };
                    if (vErrors === null) {
                      vErrors = [err69];
                    } else {
                      vErrors.push(err69);
                    }
                    errors++;
                  } else {
                    errors = _errs108;
                    if (vErrors !== null) {
                      if (_errs108) {
                        vErrors.length = _errs108;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                }
              } else {
                const err70 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/examples',
                  schemaPath: '#/definitions/field/properties/examples/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                  schema: schema21.properties.examples.type,
                  parentSchema: schema21.properties.examples,
                  data: data39,
                };
                if (vErrors === null) {
                  vErrors = [err70];
                } else {
                  vErrors.push(err70);
                }
                errors++;
              }
            }
            if (data33.default !== undefined) {
              let data41 = data33.default;
              const _errs114 = errors;
              let valid39 = false;
              let passing5 = null;
              const _errs115 = errors;
              if (typeof data41 !== 'string') {
                const err71 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/default',
                  schemaPath:
                    '#/definitions/field/properties/default/oneOf/0/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.default.oneOf[0].type,
                  parentSchema: schema21.properties.default.oneOf[0],
                  data: data41,
                };
                if (vErrors === null) {
                  vErrors = [err71];
                } else {
                  vErrors.push(err71);
                }
                errors++;
              }
              var _valid5 = _errs115 === errors;
              if (_valid5) {
                valid39 = true;
                passing5 = 0;
              }
              const _errs117 = errors;
              if (!(typeof data41 == 'number' && isFinite(data41))) {
                const err72 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/default',
                  schemaPath:
                    '#/definitions/field/properties/default/oneOf/1/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                  schema: schema21.properties.default.oneOf[1].type,
                  parentSchema: schema21.properties.default.oneOf[1],
                  data: data41,
                };
                if (vErrors === null) {
                  vErrors = [err72];
                } else {
                  vErrors.push(err72);
                }
                errors++;
              }
              var _valid5 = _errs117 === errors;
              if (_valid5 && valid39) {
                valid39 = false;
                passing5 = [passing5, 1];
              } else {
                if (_valid5) {
                  valid39 = true;
                  passing5 = 1;
                }
                const _errs119 = errors;
                if (typeof data41 !== 'boolean') {
                  const err73 = {
                    instancePath:
                      instancePath +
                      '/patternProperties/' +
                      key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                      '/default',
                    schemaPath:
                      '#/definitions/field/properties/default/oneOf/2/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema21.properties.default.oneOf[2].type,
                    parentSchema: schema21.properties.default.oneOf[2],
                    data: data41,
                  };
                  if (vErrors === null) {
                    vErrors = [err73];
                  } else {
                    vErrors.push(err73);
                  }
                  errors++;
                }
                var _valid5 = _errs119 === errors;
                if (_valid5 && valid39) {
                  valid39 = false;
                  passing5 = [passing5, 2];
                } else {
                  if (_valid5) {
                    valid39 = true;
                    passing5 = 2;
                  }
                }
              }
              if (!valid39) {
                const err74 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/default',
                  schemaPath: '#/definitions/field/properties/default/oneOf',
                  keyword: 'oneOf',
                  params: { passingSchemas: passing5 },
                  message: 'must match exactly one schema in oneOf',
                  schema: schema21.properties.default.oneOf,
                  parentSchema: schema21.properties.default,
                  data: data41,
                };
                if (vErrors === null) {
                  vErrors = [err74];
                } else {
                  vErrors.push(err74);
                }
                errors++;
              } else {
                errors = _errs114;
                if (vErrors !== null) {
                  if (_errs114) {
                    vErrors.length = _errs114;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data33.deprecated !== undefined) {
              let data42 = data33.deprecated;
              if (typeof data42 !== 'boolean') {
                const err75 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/deprecated',
                  schemaPath: '#/definitions/field/properties/deprecated/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                  schema: schema21.properties.deprecated.type,
                  parentSchema: schema21.properties.deprecated,
                  data: data42,
                };
                if (vErrors === null) {
                  vErrors = [err75];
                } else {
                  vErrors.push(err75);
                }
                errors++;
              }
            }
            if (data33.storeAsHundredth !== undefined) {
              let data43 = data33.storeAsHundredth;
              if (typeof data43 !== 'boolean') {
                const err76 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/storeAsHundredth',
                  schemaPath:
                    '#/definitions/field/properties/storeAsHundredth/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                  schema: schema21.properties.storeAsHundredth.type,
                  parentSchema: schema21.properties.storeAsHundredth,
                  data: data43,
                };
                if (vErrors === null) {
                  vErrors = [err76];
                } else {
                  vErrors.push(err76);
                }
                errors++;
              }
            }
            if (data33.displayName !== undefined) {
              let data44 = data33.displayName;
              if (typeof data44 !== 'string') {
                const err77 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/displayName',
                  schemaPath: '#/definitions/field/properties/displayName/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.displayName.type,
                  parentSchema: schema21.properties.displayName,
                  data: data44,
                };
                if (vErrors === null) {
                  vErrors = [err77];
                } else {
                  vErrors.push(err77);
                }
                errors++;
              }
            }
            if (data33.nullable !== undefined) {
              let data45 = data33.nullable;
              if (typeof data45 !== 'boolean') {
                const err78 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/nullable',
                  schemaPath: '#/definitions/field/properties/nullable/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                  schema: schema21.properties.nullable.type,
                  parentSchema: schema21.properties.nullable,
                  data: data45,
                };
                if (vErrors === null) {
                  vErrors = [err78];
                } else {
                  vErrors.push(err78);
                }
                errors++;
              }
            }
            if (data33.errorMessage !== undefined) {
              let data46 = data33.errorMessage;
              if (typeof data46 !== 'string') {
                const err79 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/errorMessage',
                  schemaPath:
                    '#/definitions/field/properties/errorMessage/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.errorMessage.type,
                  parentSchema: schema21.properties.errorMessage,
                  data: data46,
                };
                if (vErrors === null) {
                  vErrors = [err79];
                } else {
                  vErrors.push(err79);
                }
                errors++;
              }
            }
            if (data33.unit !== undefined) {
              let data47 = data33.unit;
              if (typeof data47 !== 'string') {
                const err80 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/unit',
                  schemaPath: '#/definitions/field/properties/unit/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.unit.type,
                  parentSchema: schema21.properties.unit,
                  data: data47,
                };
                if (vErrors === null) {
                  vErrors = [err80];
                } else {
                  vErrors.push(err80);
                }
                errors++;
              }
            }
            if (data33.unitColumn !== undefined) {
              let data48 = data33.unitColumn;
              if (typeof data48 !== 'string') {
                const err81 = {
                  instancePath:
                    instancePath +
                    '/patternProperties/' +
                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/unitColumn',
                  schemaPath: '#/definitions/field/properties/unitColumn/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                  schema: schema21.properties.unitColumn.type,
                  parentSchema: schema21.properties.unitColumn,
                  data: data48,
                };
                if (vErrors === null) {
                  vErrors = [err81];
                } else {
                  vErrors.push(err81);
                }
                errors++;
              }
            }
          } else {
            const err82 = {
              instancePath:
                instancePath +
                '/patternProperties/' +
                key2.replace(/~/g, '~0').replace(/\//g, '~1'),
              schemaPath: '#/definitions/field/type',
              keyword: 'type',
              params: { type: 'object' },
              message: 'must be object',
              schema: schema21.type,
              parentSchema: schema21,
              data: data33,
            };
            if (vErrors === null) {
              vErrors = [err82];
            } else {
              vErrors.push(err82);
            }
            errors++;
          }
        }
      } else {
        const err83 = {
          instancePath: instancePath + '/patternProperties',
          schemaPath: '#/properties/patternProperties/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
          schema: schema16.properties.patternProperties.type,
          parentSchema: schema16.properties.patternProperties,
          data: data32,
        };
        if (vErrors === null) {
          vErrors = [err83];
        } else {
          vErrors.push(err83);
        }
        errors++;
      }
    }
    if (data.dependencies !== undefined) {
      let data49 = data.dependencies;
      if (data49 && typeof data49 == 'object' && !Array.isArray(data49)) {
        for (const key3 in data49) {
          let data50 = data49[key3];
          const _errs139 = errors;
          let valid41 = false;
          const _errs140 = errors;
          if (
            !validate14(data50, {
              instancePath:
                instancePath +
                '/dependencies/' +
                key3.replace(/~/g, '~0').replace(/\//g, '~1'),
              parentData: data49,
              parentDataProperty: key3,
              rootData,
            })
          ) {
            vErrors =
              vErrors === null
                ? validate14.errors
                : vErrors.concat(validate14.errors);
            errors = vErrors.length;
          }
          var _valid6 = _errs140 === errors;
          valid41 = valid41 || _valid6;
          if (!valid41) {
            const _errs141 = errors;
            if (Array.isArray(data50)) {
              const len8 = data50.length;
              for (let i14 = 0; i14 < len8; i14++) {
                let data51 = data50[i14];
                if (typeof data51 !== 'string') {
                  const err84 = {
                    instancePath:
                      instancePath +
                      '/dependencies/' +
                      key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                      '/' +
                      i14,
                    schemaPath: '#/definitions/stringArray/items/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema17.items.type,
                    parentSchema: schema17.items,
                    data: data51,
                  };
                  if (vErrors === null) {
                    vErrors = [err84];
                  } else {
                    vErrors.push(err84);
                  }
                  errors++;
                }
              }
              let i15 = data50.length;
              let j6;
              if (i15 > 1) {
                const indices4 = {};
                for (; i15--; ) {
                  let item4 = data50[i15];
                  if (typeof item4 !== 'string') {
                    continue;
                  }
                  if (typeof indices4[item4] == 'number') {
                    j6 = indices4[item4];
                    const err85 = {
                      instancePath:
                        instancePath +
                        '/dependencies/' +
                        key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                      schemaPath: '#/definitions/stringArray/uniqueItems',
                      keyword: 'uniqueItems',
                      params: { i: i15, j: j6 },
                      message:
                        'must NOT have duplicate items (items ## ' +
                        j6 +
                        ' and ' +
                        i15 +
                        ' are identical)',
                      schema: true,
                      parentSchema: schema17,
                      data: data50,
                    };
                    if (vErrors === null) {
                      vErrors = [err85];
                    } else {
                      vErrors.push(err85);
                    }
                    errors++;
                    break;
                  }
                  indices4[item4] = i15;
                }
              }
            } else {
              const err86 = {
                instancePath:
                  instancePath +
                  '/dependencies/' +
                  key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                schemaPath: '#/definitions/stringArray/type',
                keyword: 'type',
                params: { type: 'array' },
                message: 'must be array',
                schema: schema17.type,
                parentSchema: schema17,
                data: data50,
              };
              if (vErrors === null) {
                vErrors = [err86];
              } else {
                vErrors.push(err86);
              }
              errors++;
            }
            var _valid6 = _errs141 === errors;
            valid41 = valid41 || _valid6;
          }
          if (!valid41) {
            const err87 = {
              instancePath:
                instancePath +
                '/dependencies/' +
                key3.replace(/~/g, '~0').replace(/\//g, '~1'),
              schemaPath:
                '#/properties/dependencies/additionalProperties/anyOf',
              keyword: 'anyOf',
              params: {},
              message: 'must match a schema in anyOf',
              schema:
                schema16.properties.dependencies.additionalProperties.anyOf,
              parentSchema:
                schema16.properties.dependencies.additionalProperties,
              data: data50,
            };
            if (vErrors === null) {
              vErrors = [err87];
            } else {
              vErrors.push(err87);
            }
            errors++;
          } else {
            errors = _errs139;
            if (vErrors !== null) {
              if (_errs139) {
                vErrors.length = _errs139;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err88 = {
          instancePath: instancePath + '/dependencies',
          schemaPath: '#/properties/dependencies/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
          schema: schema16.properties.dependencies.type,
          parentSchema: schema16.properties.dependencies,
          data: data49,
        };
        if (vErrors === null) {
          vErrors = [err88];
        } else {
          vErrors.push(err88);
        }
        errors++;
      }
    }
    if (data.type !== undefined) {
      let data52 = data.type;
      if ('object' !== data52) {
        const err89 = {
          instancePath: instancePath + '/type',
          schemaPath: '#/properties/type/const',
          keyword: 'const',
          params: { allowedValue: 'object' },
          message: 'must be equal to constant',
          schema: 'object',
          parentSchema: schema16.properties.type,
          data: data52,
        };
        if (vErrors === null) {
          vErrors = [err89];
        } else {
          vErrors.push(err89);
        }
        errors++;
      }
    }
  } else {
    const err90 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
      schema: schema16.type,
      parentSchema: schema16,
      data,
    };
    if (vErrors === null) {
      vErrors = [err90];
    } else {
      vErrors.push(err90);
    }
    errors++;
  }
  validate14.errors = vErrors;
  return errors === 0;
}
